import React from "react";
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";
import Testimonial from "./components/tesimonial/Testimonial";
import ScrollToTop from "react-scroll-to-top";
import { FaChevronUp } from "react-icons/fa";

function App() {
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
      <Navbar />
      <div className="max-w-screen-xl mx-auto">
        <ScrollToTop
          smooth
          component={<FaChevronUp />} // Using a nice arrow icon
          style={{
            backgroundColor: "cyan",
            opacity: "0.8", // Button color
            borderRadius: "50%", // Circular button
            color: "#fff", // Text color
            padding: "10px", // Padding inside the button
            fontSize: "20px", // Font size
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Box shadow
            right: "30px", // Position from the right
            bottom: "30px", // Position from the bottom
            position: "fixed", // Fixed position to stay on scroll
            zIndex: 1000, // Ensure it's on top of other elements
          }}
        />

        <Banner />
        <Features />

        <Resume />
        <Projects />
        {/* <Testimonial /> */}
        <Contact />
        {/* <Footer /> */}
        <FooterBottom />
      </div>
    </div>
  );
}

export default App;
